import {useMemo} from 'react';
import {useQuery} from 'react-query';
import SpaceApiService from '@/modules/admin/services/SpaceApiService';

export const useGetServicesTemplatesGoal = (spaceId) => {
  const queryConfig = useMemo(() => {
    return {enabled: !!(spaceId)};
  }, [spaceId]);

  const {data, isLoading} = useQuery(['services-template-goal', spaceId], async () => {
    const {data} = await SpaceApiService.getServicesTemplatesGoal(spaceId);
    return data;
  }, queryConfig);
  return {isLoading, data};
};

